var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showUpdate
    ? _c(
        "div",
        { staticClass: "update-results" },
        [
          _c("div", { staticClass: "update-results-content" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "32",
                  height: "32",
                  viewBox: "0 0 32 32",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M17.1429 20.5625C17.1429 20.7232 17.0179 20.8571 16.8571 20.8571H15.1429C14.9821 20.8571 14.8571 20.7232 14.8571 20.5625V18.8661C14.8571 18.7054 14.9821 18.5714 15.1429 18.5714H16.8571C17.0179 18.5714 17.1429 18.7054 17.1429 18.8661V20.5625ZM17.125 17.2232C17.1161 17.3393 16.9821 17.4286 16.8214 17.4286H15.1696C15 17.4286 14.8661 17.3393 14.8661 17.2232L14.7143 13.1429C14.7143 13.0893 14.7411 13 14.8036 12.9554C14.8571 12.9107 14.9375 12.8571 15.0179 12.8571H16.9821C17.0625 12.8571 17.1429 12.9107 17.1964 12.9554C17.2589 13 17.2857 13.0714 17.2857 13.125L17.125 17.2232ZM17 8.88393C16.8036 8.51786 16.4196 8.28571 16 8.28571C15.5804 8.28571 15.1964 8.51786 15 8.88393L8.14286 21.4554C7.94643 21.8036 7.95536 22.2321 8.16071 22.5804C8.36607 22.9286 8.74107 23.1429 9.14286 23.1429H22.8571C23.2589 23.1429 23.6339 22.9286 23.8393 22.5804C24.0446 22.2321 24.0536 21.8036 23.8571 21.4554L17 8.88393Z",
                    fill: "#FED25A",
                  },
                }),
              ]
            ),
            _c("b", [
              _vm._v(
                "Wyniki na stronie dla uczestników nie zostały zaktualizowane"
              ),
            ]),
          ]),
          _c(
            "base-button",
            {
              attrs: { btn9: "" },
              on: {
                click: function ($event) {
                  return _vm.updateResults()
                },
              },
            },
            [_vm._v(" Uaktualnij wyniki ")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }